export default __webpack_public_path__ + "static/Concept1-426d9a59fc9283c785361a3e65b817c0.png";